$(document).ready(function () {
	$(".toogle-site-map").each(function () {
		$(this).click(function () {
			$(this).parents(".opened").find("> ul > .hidden").removeClass("hidden");
			$(this).parents(".opened").find("> .toogle-link").addClass("pointer");
			$(this).css("visibility","hidden");
		})
	})
});